/* eslint-disable check-file/filename-blocklist */

export enum ActionStatus {
	LOADING = 'loading',
	ERROR = 'error',
	SUCCESS = 'success',
}

export const LINK_TO_SUPPORT_CONTACT = 'https://support.atlassian.com/contact/#/';
export const ARCHIVE_SUPPORT_LINK =
	'https://support.atlassian.com/confluence-cloud/docs/archive-pages/';
export const DELETE_SUPPORT_LINK =
	'https://support.atlassian.com/confluence-cloud/docs/delete-restore-or-purge-a-page/';
export const PAGE_RESTRICTIONS_SUPPORT_LINK =
	'https://support.atlassian.com/confluence-cloud/docs/add-or-remove-page-restrictions/';

export enum ContentStatus {
	ARCHIVED = 'archived',
	RESTORED = 'restored',
	// Trashed pages can be restored.
	TRASHED = 'trashed',
}

// We are using a separate selection limit for Delete than for Archive/Restore due to BE
// performance issues, and using a FF so it is quick and easy to change if necessary
export const BULK_DELETE_PAGE_SELECTION_LIMIT_DEFAULT = 100;
